import { NavLink, useParams } from "react-router";
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "./ui/sidebar";
import { useDeviceGroupDetail } from "@/api/device-group-http-functions";
import { Skeleton } from "./ui/skeleton";

export const OrganisationSidebar = ({
    ...props
}: React.ComponentProps<"div"> & {
    side?: "left" | "right";
    variant?: "sidebar" | "floating" | "inset";
    collapsible?: "offcanvas" | "icon" | "none";
}) => {
    const { deviceGroupTag } = useParams<{ deviceGroupTag: string }>();
    const { data: organisation, isLoading } = useDeviceGroupDetail(
        deviceGroupTag!,
    );
    return (
        <Sidebar {...props}>
            {props.children}
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>
                        {isLoading ? (
                            <Skeleton className="h-[32px] w-[200]" />
                        ) : (
                            organisation?.deviceGroupName
                        )}
                    </SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <NavLink
                                        className={"text-default-color"}
                                        to={`/manage-customers/organisations/${organisation?.organisationId}/overview`}
                                    >
                                        <span>Overview</span>
                                    </NavLink>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <NavLink
                                        className={"text-default-color"}
                                        to={`/manage-customers/organisations/${organisation?.organisationId}/devices`}
                                    >
                                        <span>Devices</span>
                                    </NavLink>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
};
